function currentSlide(n) {
  showSlides((slideIndex = n));
}

function showSlides(n) {
  let i;
  let slides = document.getElementsByClassName("mySlides");
  let dots = document.getElementsByClassName("dot");
  if (n > slides.length) {
    slideIndex = 1;
  }
  if (n < 1) {
    slideIndex = slides.length;
  }
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  for (i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" dot-active", "");
  }
  slides[slideIndex - 1].style.display = "block";
  dots[slideIndex - 1].className += " dot-active";
  seeFewerFeature();
}

$(document).ready(function () {
  var modal = $(".modal");
  var overlay = $(".overlay");
  var close = $(".close-registration_reward");
  var popup_reward = $(".popup-reward-modal");

  const closeModal = function () {
    modal.addClass("hidden");
    overlay.addClass("hidden");
    popup_reward.addClass("hidden");
  };
  overlay.click(closeModal);
  close.click(closeModal);
  $(".cancel-popup-button").click(closeModal);

  function openPopup(popuplink) {
    popuplink.nextAll(".overlay,.modal").removeClass("hidden");
  }

  $(".see-tier-benefit").click(function () {
    openPopup($(this));
  });

  $(".card-qr").click(function () {
    openPopup($(this));
  });
});

function seeAllFeature(){
  $(".see-all").addClass("hidden");
  $(".see-fewer").removeClass("hidden");
  var active_tier = document.getElementsByClassName("dot-active")[0].id;
  let hidden_lines = '';
  if (active_tier == "dotGold"){
    hidden_lines = document.getElementsByClassName("gold-hidden-line");
  } else if (active_tier == "dotPlatinum"){
    hidden_lines = document.getElementsByClassName("platinum-hidden-line");
  }
  for (let i = 0; i < hidden_lines.length; i++){
    hidden_lines[i].classList.remove("hidden");
  }
}
function seeFewerFeature(){
    $(".see-all").removeClass("hidden");
    $(".see-fewer").addClass("hidden");
    var active_tier = document.getElementsByClassName("dot-active")[0].id;
    let hidden_lines = '';
    if (active_tier == "dotGold"){
      hidden_lines = document.getElementsByClassName("gold-hidden-line");
    } else if (active_tier == "dotPlatinum"){
      hidden_lines = document.getElementsByClassName("platinum-hidden-line");
    }
    for (let i = 0; i < hidden_lines.length; i++){
      hidden_lines[i].classList.add("hidden");
    }
}

function pageOnLoad(cus_phone) {
  var settings = {
    url: "https://api.backend.gw.t.int.suparagroup.com/gq-connect/auth/token",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      api_key: "98931F7B-B67D-492C-96F1-A50D66C4DA1B",
      client: "magenest",
    }),
  };

  $.ajax(settings).done(function (response) {
    supara_token = response.data.token;
    var ajax_customer = {
      url: "https://api.backend.gw.t.int.suparagroup.com/gq-connect/customers/get?mobile=" + parseInt(cus_phone) + "&source=INSTORE",
      method: "GET",
      timeout: 0,
      headers: {
        Authorization: "Bearer " + response.data.token,
      },
    };

    $.ajax(ajax_customer).done(function (cus) {
      document.getElementById("cardTierName").innerText =
        cus.data.customers[0].current_slab;
      if (cus.data.customers[0].current_slab == "Platinum") {
        $("#tierSilver").css("display", "none");
        $("#tierPlatinum").css("display", "block");
        $("#dotPlatinum").addClass("dot-active");
        $("#unlockGold").css("display", "none");
        $("#unlockPlatinum").css("display", "none");
      } else if (cus.data.customers[0].current_slab == "Silver"){
          $("#tierSilver").css("display", "block");
          $("#dotSilver").addClass("dot-active");
      } else if (cus.data.customers[0].current_slab == "Gold"){
        $("#tierSilver").css("display", "none");
        $("#tierGold").css("display", "block");
        $("#dotGold").addClass("dot-active");
        $("#unlockGold").css("display", "none");
      }
      document.getElementById("cartPoint").innerText =
        cus.data.customers[0].points_summaries[0].total_available_points;
      document.getElementById("slapExpirePoint").innerText =
        cus.data.customers[0].expiry_points[0].points;
      document.getElementById("point_to_next_tier").innerText =
        cus.data.customers[0].tier_info.min_purchase_value_required;
      const date = new Date(
        cus.data.customers[0].expiry_points[0].expiry_date
      );
      const formattedDate = new Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date);
      document.getElementById("slapExpireDate").innerText = formattedDate;
    });
  });
  // let now = new Date();

  // let hours = now.getHours();
  // let minutes = now.getMinutes();
  // let seconds = now.getSeconds();
  // let formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
  //   .toString()
  //   .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  // document.getElementById("current-time").innerText = formattedTime;
}
